module.exports = __webpack_public_path__ + "Roboto-Black.44236ad507eddcbfd986.ttf";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-Black.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Black.ttf
// module chunks = 5